import Big from 'big.js'

// eslint-disable-next-line complexity
function calculateBoost(data) {
  const X = Big(10)
  const Y = Big(45)
  const Z = Big(45)
  const DIVISOR = Big(100)

  const esMETTotalSupply = Big(data.esMETTotalSupply || '0')
  const lpTotalSupply = Big(data.lpTotalSupply || '0')
  const synthTotalSupply = Big(data.synthTotalSupply || '0')

  const esMETBalance = Big(data.esMETBalance || '0')
  const lpBalance = Big(data.lpBalance || '0')
  const synthBalance = Big(data.synthBalance || '0')

  let step1 = 0
  let step2 = 0
  let step3 = 0

  if (Big(synthBalance).gt(0)) {
    // Step 1: 0.1 * SFDollarProvided(aka SynthBalance in USD)
    step1 = Big(X).times(synthBalance).div(DIVISOR)
  } else {
    // if user has no synth balance then there is no boost
    return 0
  }

  if (
    Big(esMETBalance).gt(0) &&
    Big(esMETTotalSupply).gt(0) &&
    Big(synthTotalSupply).gt(0)
  ) {
    // Step 2: 0.45 * TotalSFLiquidity (esMETVotingBalance / VotingTotal)
    step2 = Big(Y)
      .times(synthTotalSupply)
      .times(esMETBalance)
      .div(esMETTotalSupply)
      .div(DIVISOR)
  }
  if (
    Big(lpBalance).gt(0) &&
    Big(lpTotalSupply).gt(0) &&
    Big(synthTotalSupply).gt(0)
  ) {
    // Step 3: 0.45 * TotalSFLiquidity (synthLPBalance / synthLP)
    step3 = Big(Z)
      .times(synthTotalSupply)
      .times(lpBalance)
      .div(lpTotalSupply)
      .div(DIVISOR)
  }

  const stepTotal = Big(step1).plus(step2).plus(step3)
  // Step 4: Smart farming boost = minimumOf((step1 + step2 + step3), SFDollarProvided)
  return stepTotal.gt(synthBalance)
    ? synthBalance.toFixed()
    : stepTotal.toFixed()
}

export default calculateBoost
